//import HARDCODE from '../../../business-const/HardCode/HardCode'

import {
    WhatsApp,
} from '../../../business-components/WhatsApp/WhatsApp'

import {
    pesquisaList,
} from '../../../business-rules/List/ListService'



export const WhatsAppUsuario = ({ item, equipeList }) => {

    const linhaEquipeList = pesquisaList(equipeList, item.id)

    return (
        linhaEquipeList.celular
            ?
                <WhatsApp
                    className='ml-1 mt-2'
                    numero={linhaEquipeList.celular}
                />
            :
                ''
    )
}